import { Icon } from "@opendash/icons";
import { Button, Space, Table, Tag, Tooltip } from "antd";
import { ColumnType } from "antd/es/table";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { SIV_GoodsReceiving } from "../../../parsegenerated";

type Props = {
  goodsReceivings: SIV_GoodsReceiving[];
  loading?: boolean;
  onViewItems?: (receiving: SIV_GoodsReceiving) => void;
};

export const GoodsReceivingTable = observer((props: Props) => {
  const { goodsReceivings, loading, onViewItems } = props;

  const columns: ColumnType<SIV_GoodsReceiving>[] = [
    {
      title: "Nr.",
      dataIndex: "no",
      key: "no",
      sorter: (a, b) => a.no.localeCompare(b.no),
    },
    {
      title: "Datum",
      dataIndex: "date",
      key: "date",
      render: (date: Date) => (date ? dayjs(date).format("DD.MM.YYYY") : "-"),
      sorter: (a, b) => {
        if (!a.date || !b.date) return 0;
        return dayjs(a.date).valueOf() - dayjs(b.date).valueOf();
      },
    },
    {
      title: "Menge",
      dataIndex: "amount",
      key: "amount",
      render: (val: number) => (val !== undefined ? val : "-"),
    },
    {
      title: "Lagerort",
      dataIndex: "storageLocation",
      key: "storageLocation",
      render: (val: string) =>
        val ? (
          <Tag color="blue">
            <Icon icon="fa:warehouse" /> {val}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Projekt",
      dataIndex: "project",
      key: "project",
      render: (val: string) => val || "-",
    },
    {
      title: "Lieferant",
      dataIndex: "supplier",
      key: "supplier",
      render: (val: string) => val || "-",
    },
    {
      title: "Beschreibung",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      render: (val: string) => val || "-",
    },
    {
      title: "Lieferschein",
      key: "deliveryNote",
      render: (_, record) =>
        record.deliveryNote ? (
          <Tag color="green">{record.deliveryNote.no}</Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Aktionen",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space.Compact>
          {onViewItems && (
            <Tooltip title="Inhalte anzeigen">
              <Button
                size="small"
                icon={<Icon icon="fa:list" />}
                onClick={() => onViewItems(record)}
              />
            </Tooltip>
          )}
        </Space.Compact>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={goodsReceivings}
      loading={loading}
      rowKey={(record) => record.id!}
      size="small"
      pagination={{ pageSize: 10 }}
    />
  );
});
